import ViewController from "core/views/view.controller";

export default class BookingColorSelectionCtrl extends ViewController {
    static $inject = ['$scope', 'Bookings'];

    constructor() {
        super(...arguments);
        this.colors = [];

        // Bindings
        this.color = null;
        this.colorCols = null;
        this.colorRowClass = null;
        this.colorColClass = null;
        this.onColorSelected = null;
    }

    $onInit() {
        this.Bookings.colors()
            .then((colors) => {
                this.colors = colors.map($ => $.background);

                if (!this.colorCols) {
                    this.colorCols = this.colors.length;
                }

                this.colorRows = [];
                for (var i = 0; i < this.colors.length; i += this.colorCols) {
                    this.colorRows.push(this.colors.slice(i, i + this.colorCols));
                }

                console.log(this.colors);
            });

    }

    $onChanges(changes) {
        if (changes.colorCols && this.colorCols == null) {
            this.colorCols = this.colors.length;
        }
    }

    selectColor(color) {
        this.color = color;

        if (this.onColorSelected instanceof Function) {
            this.onColorSelected({
                color: color
            });
        }
    };

}



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-color-selection/booking-color-selection.controller.js